import { j as r } from "../../../../node_modules/react/jsx-runtime.js";
import { createContext as s, useState as i } from "react";
const d = s({
  loading: !1,
  // @ts-ignore
  updateLoading: (o) => {
  }
}), p = ({ children: o }) => {
  const [t, e] = i(!1), a = (n) => {
    e(n);
  };
  return /* @__PURE__ */ r.jsx(
    d.Provider,
    {
      value: {
        loading: t,
        updateLoading: a
      },
      children: o
    }
  );
};
export {
  d as TableContext,
  p as TableProvider
};
//# sourceMappingURL=Table.js.map
